import { useState } from "react";
import { readPersistedColumnVisibility, writePersistedColumnVisibility } from "./column-visibility-storage";
import { useEffectAfterMount } from "./useEffectAfterMount";
/**
 * Column-visibility state seeded from, and persisted to, localStorage.
 *
 * The state is seeded once on mount (like the plain `useState` it replaced):
 * later URL edits aren't re-read here — in-session toggles flow through the
 * table's own change handler. On mount it's layered low → high precedence:
 *
 *   initialColumnVisibility  →  saved preference  →  URL (shareable, hidden-only)
 *
 * so a remembered preference overrides the code default. Because the URL form is
 * hidden-only, it can only override a saved preference *toward hidden* — it can
 * never restore a column the saved preference un-hid.
 *
 * Without a `tableId` the persistence calls no-op, so the hook degrades to plain
 * `useState` for anonymous tables.
 */ export function usePersistedColumnVisibility({ tableId, initialColumnVisibility, urlColumnVisibility, enableUrlState }) {
    const [columnVisibility, setColumnVisibility] = useState(()=>({
            ...initialColumnVisibility,
            ...readPersistedColumnVisibility(tableId) ?? {},
            ...enableUrlState ? urlColumnVisibility : {}
        }));
    useEffectAfterMount(()=>{
        writePersistedColumnVisibility(tableId, columnVisibility);
    }, [
        tableId,
        columnVisibility
    ]);
    return [
        columnVisibility,
        setColumnVisibility
    ];
}

//# sourceMappingURL=usePersistedColumnVisibility.js.map